<template>
  <pea-table
    :tableData="tableData"
    :page="page"
    :pageSize="pageSize"
    :resultTotal="resultTotal"
    :status="status"
    :tableLoading="tableLoading"
    :selectRow="selectRow"
    :currentChange="getPeas"
    :rowStyle="rowStyle"
  >
  </pea-table>
</template>

<script>
import router from '@/router'
import Filter from '@/components/utility/filter.js'
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'advancedSearchTable',
  props: {
    filter: {
      default: new Filter()
    }
  },
  data () {
    return {
      tableData: null,
      page: 1,
      pageSize: 5,
      resultTotal: 0,
      status: 1,
      searchId: 0,
      tableLoading: false
    }
  },
  methods: {
    getPeas: function () {
      this.tableLoading = true
      if (this.filter.filterString === '') {
        this.filter.buildFilterString()
      }
      if (this.filter.filterString !== '') {
        var call = '/searchPEAs?filter=' + this.filter.filterString + '&page=' + this.page + '&pageSize=' + this.pageSize
        this.$axios.get(call).then(response => {
          this.tableLoading = false
          this.tableData = response.data.results
          this.resultTotal = response.data.totalRecords
        }).catch(reject => {
          this.tableLoading = false
          this.tableData = null
          this.resultTotal = 0
          helperMethods.showNotification(this.$parent, 'Error Performing search', reject.body, 'error', 30000, '')
        })
      } else {
        this.tableLoading = false
        this.tableData = null
        this.resultTotal = 0
      }
    },
    search: function () {
      this.filter.buildFilterString()
      router.push({name: 'advancedSearch', params: {filter: this.filter}})
    },
    selectRow: function (row) {
      router.push('/editPea/' + row.id)
    },
    rowStyle () {
      return 'cursor: pointer;'
    }
  },
  mounted () {
    if (this.$route.query.filter !== undefined) {
      this.filter.splitString(this.$route.query.filter)
      this.$parent.$emit('filterUpdate', this.filter)
      this.getPeas()
    }
  },
  created: function () {
    this.$on('page', function (value) {
      this.page = value
    })
    this.$on('pageSize', function (value) {
      this.pageSize = value
    })
    this.$on('resultTotal', function (value) {
      this.resultTotal = value
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
